
import React from 'react';
import ZLog from './zlog';
import ZUtil from './zutil';
import { APP } from "./App";
import AMC from "./AMC";
import { ROUTER } from './AMCRouter';
import ZNetwork from "./znetwork";
import { loadStripe } from '@stripe/stripe-js';
const stripePromise = loadStripe(ZUtil.isProduction() ? "pk_live_JajY13V1ShkQ5S6A85FfVmJx00QPmyHNLb" : "pk_test_yzjFABktePoQQDGMMc1CaqeC00egMEmbYg");

export default class AMCStripeCheckoutButton extends React.Component {
	constructor(props) {
		super(props);
		this.state = { };
	}
	handleClick = async (event) => {
		let { plan, products } = this.props;
		const stripe = await stripePromise;
ZLog.log("AMCStripeCheckout plan=", plan);
ZLog.log("AMCStripeCheckout products=", products);

		ZNetwork.post("checkout:start", { plan_id: plan && plan.id, product_id: products && products[0] }, async (err, session) => {
			if (!session) {
				return APP.setError("Unable to create checkout session. Please try again later.");
			}
			if (session.is_upgrade_or_downgrade) {
				AMC.setUser(session.user);
				APP.setBanner(session.msg);
				return ROUTER.pushRoute("/-/pricing");
			}
			let result = await stripe.redirectToCheckout({ sessionId: session.id });
			if (result.error) {
				APP.setError(result.error.message);
			}
		});
	}
	render() {
		let { label } = this.props;
		return (
			<button className="AMCPlansTablePriceButton" role="link" onClick={this.handleClick}>
				{label}
			</button>
		);
	}
}




// WEBPACK FOOTER //
// ./src/AMCStripeCheckout.js